'use-strict';

import { IScope } from 'angular';
import { SettingsAPIService } from '../../../shared/api/settings-api.service';
import { ConfigService } from '../../../shared/config/config.service';
import { InterfaceService } from '../../../shared/interface/interface.service';
import { EExternalAPI } from '../../../src/app/@shared-types/api';
import { SchwackeAPIConfig } from '../../../src/app/@shared-types/api/schwacke';
import LogService from '../../../src/app/shared/services/log';
import { ToastService, ToastType } from '../../../ui-components/toast/toast.service';

/* @ngInject */
export default class SchwackeAPIController {
  private $scope: IScope;

  public schwackeAPIConfig: SchwackeAPIConfig | null = null;

  public importing = false;

  private settingsApiService: SettingsAPIService;

  private interfaceService: InterfaceService;

  private toastService: ToastService;

  private logService: LogService;

  public locations: { [key: string]: string } | null;

  public notificationAdmins: string | null = null;

  constructor(
    $scope: IScope,
    settingsApiService: SettingsAPIService,
    interfaceService: InterfaceService,
    toastService: ToastService,
    configService: ConfigService,
    logService: LogService,
  ) {
    this.settingsApiService = settingsApiService;
    this.interfaceService = interfaceService;
    this.$scope = $scope;
    this.toastService = toastService;
    this.logService = logService;

    this.getSchwackeConfig();
    this.locations = configService.get('general_locations');
  }

  private getSchwackeConfig = async (): Promise<void> => {
    const configs = await this.settingsApiService
      .getAPIConfig<SchwackeAPIConfig[]>(EExternalAPI.SCHWACKE).catch();

    [this.schwackeAPIConfig] = configs;
    this.interfaceService.applyScope(this.$scope);
  };

  public updateConfig = (
    config: unknown,
  ): Promise<void> => this.settingsApiService.updateAPIConfig(EExternalAPI.SCHWACKE, config)
    .then(() => this.toastService.toast(ToastType.SUCCESS, 'Einstellungen gespeichert.'));
}
